export const subToId = sub => sub.replace("|", "-")
